/* Wishlist MVP */
import { scrollToElement, createElement } from "@scripts/components/functions.js";
let TOP_OFFSET = 52;

document.addEventListener( 'DOMContentLoaded', function() {

    const wToggler = document.querySelector('.btn--wishlist');
    let wKey = '_wishlist';
    if (wToggler instanceof HTMLElement && wToggler.dataset['storage']) {
      wKey = wKey + '_' + String(wToggler.dataset.storage);
    }
    const wishlistStore = localStorage.getItem(wKey) ? JSON.parse( localStorage.getItem(wKey) ) : {};

    const wTogglerCounter = wToggler.querySelector('span');
    const wSidebar = document.querySelector('.wishlist');
    const wSidebarContent = wSidebar.querySelector('.wishlist__content');
    const wSidebarFooterBtn = wSidebar.querySelector('.wishlist__footer button');
    const wOverlay = document.querySelector('.nav-overlay');
  
    wOverlay.addEventListener( 'click', function(){
      wSidebar.classList.remove('wishlist--toggled');
  }, true );

  wSidebarFooterBtn.addEventListener( 'click', function(){
      wSidebar.classList.remove('wishlist--toggled');
  }, true );

    function updateWishlistComponents() {
      Object.keys(wishlistStore).forEach(id => {
        document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(btn => {
          btn.classList.add('ez-wish--active');
        });
      });
  
      wTogglerCounter.textContent = Object.keys(wishlistStore).length;
      wToggler.style.visibility = !Object.keys(wishlistStore).length ? 'hidden' : '';
      if ( !Object.keys(wishlistStore).length ) {
        wSidebar.classList.remove('wishlist--toggled');
      }
  
      localStorage.setItem(wKey, JSON.stringify(wishlistStore));
    }
    // inital state update
    updateWishlistComponents();
  
    document.querySelectorAll('.ez-wish').forEach(wishItBtn => {
      wishItBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent other events on click this
        dishName = e.currentTarget.parentElement.querySelector('.ez-item__name')?.textContent
        id = e.currentTarget.dataset.id
  
        if (wishlistStore[id]) {
          delete wishlistStore[id];
          document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(btn => {
            btn.classList.remove('ez-wish--active');
          });
        } else {
          wishlistStore[id] = dishName;
          document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(btn => {
            btn.classList.add('ez-wish--active');
          });
        }
  
        // update every time when click heart btn on items
        updateWishlistComponents();
      })
    });
  
    wToggler.addEventListener( 'click', function() {
      wSidebar.classList.toggle('wishlist--toggled');
      wSidebarContent.innerHTML = '';
  
      Object.keys(wishlistStore).forEach(id => {
  
        /* Create SVG element */
        var svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
              useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            svgElem.classList.add('icon');
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-basket');
            svgElem.appendChild(useElem);
  
        let itemRemover = createElement("button", {class: 'wishlist__remover'}, svgElem);
  
        let item = createElement("div", {class: 'wishlist__item'},
          createElement("div", {class: 'wishlist__item-name'}, wishlistStore[id]),
          itemRemover
        );
  
        wSidebarContent.appendChild(item);
  
        item.addEventListener('click', function(){
          let validScrollTarget = null;
          document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(wishBtn => {
            if (!validScrollTarget && wishBtn.offsetParent !== null) { // check target button exists and visible
              validScrollTarget = wishBtn;
            }
          });
          if ( validScrollTarget ) {
            scrollToElement(validScrollTarget);
          } else {
            item.classList.add('inactive');
          }
        });
  
        itemRemover.addEventListener('click', (e)=> {
          e.stopPropagation(); // Prevent other events on click this
          item.remove();
          document.querySelectorAll('.ez-wish[data-id="' + id + '"]').forEach(wishItBtn => {
            wishItBtn.classList.remove('ez-wish--active');
          });
          delete wishlistStore[id];
          // update when click remove btn in wishlist
          updateWishlistComponents();
        });
      });
  
    } );
  
  } );